import Button from 'client/components/entities/Button'
import * as types from 'common/types'
import PropTypes from 'prop-types'
import React from 'react'
import { useCustomLoginDescendantIds } from './CustomLogin'

function CustomLoginButton({ entity, isMoveDownAllowed, isMoveUpAllowed }) {
  const entityIds = useCustomLoginDescendantIds()
  return (
    <Button
      entity={entity}
      isMoveDownAllowed={isMoveDownAllowed}
      isMoveUpAllowed={isMoveUpAllowed}
      isRemoveAllowed={false}
      isSaveAllowed={false}
      isCopyAllowed={false}
      dropBoxAllowedEntityIds={entityIds}
    />
  )
}

CustomLoginButton.propTypes = {
  entity: types.entity.isRequired,
  isMoveUpAllowed: PropTypes.bool.isRequired,
  isMoveDownAllowed: PropTypes.bool.isRequired,
}

export default CustomLoginButton
